module.exports = __webpack_public_path__ + "static/media/enhancement.e78355a3.png";